import styled from "styled-components";

export const ToastContainer = styled.div`
  display: flex;
  /* padding: 0px 2px 2px 2px; */
  flex-direction: column;
  background-color: ${({ $tipo }) => {
    if ($tipo === "success") {
      return "hsla(128, 43%, 42%, 1)";
    } else if ($tipo === "danger") {
      return "hsla(4, 100%, 40%, 1);";
    } else if ($tipo === "info") {
      return "hsla(202, 100%, 30%, 1)";
    } else {
      return "hsla(24, 100%, 50%, 1);";
    }
  }};
  color: white;
  border-radius: 6px;
  position: fixed;
  ${({ $posicion }) => {
    if ($posicion === "center-up") {
      return `top: 50px; left: 50%; transform: translateX(-50%);`;
    } else if ($posicion === "center-down") {
      return `bottom: 40px; left: 50%; transform: translateX(-50%);`;
    } else if ($posicion === "left-up") {
      return `top: 20px; left: 20px;`;
    } else if ($posicion === "left-down") {
      return `bottom: 20px; left: 20px;`;
    } else if ($posicion === "right-up") {
      return `top: 20px; right: 20px;`;
    } else if ($posicion === "right-down") {
      return `bottom: 20px; right: 20px;`;
    } else {
      return `top: 40px; left: 50%; transform: translateX(-50%);`;
    }
  }}
  min-width: 260px;
  max-width: 70vh;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  user-select: none;
  @media (max-width: 768px) {
    min-width: 360px;
  }
`;

export const ToastContent = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
`;

export const Message = styled.span`
  margin-left: 10px;
  flex-grow: 1;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
`;

export const CloseIcon = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const ProgressBar = styled.div`
  height: 4px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.58);
  border-radius: 0 0 6px 6px;
  overflow: hidden;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: white;
    animation: progress 4000ms linear forwards;
  }

  @keyframes progress {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-100%);
    }
  }
`;
